import { styled } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../styledFilter';

export const FormControlContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	padding: 0,
});

export const Button = styled(domTag('button', ['btntype']))(({ btntype }: { btntype?: 'bold' | 'outlined' | undefined }) => ({
	'height': 40,
	'background': !btntype || btntype === 'bold' ? 'var(--color-text-primary)' : 'var(--color-bg-primary)',
	'color': !btntype || btntype === 'bold' ? 'var(--color-text-inverse)' : 'var(--color-text-primary)',
	'border': !btntype || btntype === 'bold' ? 'none' : '1px solid var(--color-text-primary)',
	'fontFamily': 'var(--font-family-semibold)',
	'fontSize': 'var(--text-body-sm-size)',
	'letterSpacing': 'var(--tracking-wide)',
	'cursor': 'pointer',
	'whiteSpace': 'nowrap',
	'borderRadius': 'var(--radius-default)',
	'padding': '0 20px',
	'transition':
		'background-color var(--transition-fast), color var(--transition-fast), border-color var(--transition-fast), transform var(--transition-fast), opacity var(--transition-fast)',
	'&:hover:not(:disabled)': {
		opacity: 0.9,
	},
	'&:active:not(:disabled)': {
		transform: 'scale(0.98)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
	'&:disabled': {
		opacity: 0.4,
		cursor: 'not-allowed',
	},
	[down('md')]: {
		fontSize: 'var(--type-xs)',
		height: 30,
		padding: '0 10px',
	},
}));

export const PrimaryButton = styled(domTag('button', ['btntype']))(
	({ btntype }: { btntype?: 'bold' | 'outlined' | undefined }) => ({
		'height': 40,
		'background': !btntype || btntype === 'bold' ? 'var(--color-brand-secondary)' : 'var(--color-bg-primary)',
		'color': !btntype || btntype === 'bold' ? 'var(--color-text-inverse)' : 'var(--color-brand-secondary)',
		'border': !btntype || btntype === 'bold' ? 'none' : '1px solid var(--color-brand-secondary)',
		'fontFamily': 'var(--font-family-semibold)',
		'fontSize': 'var(--text-body-sm-size)',
		'letterSpacing': 'var(--tracking-wide)',
		'cursor': 'pointer',
		'whiteSpace': 'nowrap',
		'borderRadius': 'var(--radius-default)',
		'padding': '0 20px',
		'transition':
			'background-color var(--transition-fast), color var(--transition-fast), border-color var(--transition-fast), transform var(--transition-fast), opacity var(--transition-fast)',
		'&:hover:not(:disabled)': {
			opacity: 0.9,
		},
		'&:active:not(:disabled)': {
			transform: 'scale(0.98)',
		},
		'&:focus-visible': {
			outline: '2px solid var(--color-border-focus)',
			outlineOffset: 2,
		},
		'&:disabled': {
			opacity: 0.4,
			cursor: 'not-allowed',
		},
		[down('md')]: {
			fontSize: 'var(--type-xs)',
		},
	})
);
